import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Card, Collapse } from 'antd';
import { textQuanNoHiHaDada, tipusCampNoSuportat } from '../../constants';

const { Panel } = Collapse;

const obtenirEtiquetaDeValorTipusLlista = (valor, valorsPossibles) => {
    const valorPossibleAssociat = valorsPossibles.find(valorPossible => valorPossible.id === valor);
    return valorPossibleAssociat ? valorPossibleAssociat.valor : null;
};

const renderitzarValorTipusLlistaMultiple = (valor, valorsPossibles) => {
    return valor
        .map(valor => obtenirEtiquetaDeValorTipusLlista(valor, valorsPossibles))
        .filter(etiquetaValor => etiquetaValor !== null)
        .join(', ');
};

const renderitzarCampSegonsTipus = camp => {

    let valorRenderitzat;
    const { nom, tipus, id, valor, valorsPossibles } = camp;

    switch(tipus) {
        case 2: //Text
        case 4: //Numeric
        case 6: //Data
            valorRenderitzat = valor;
            break;

        case 3: //Llista
            if (Array.isArray(valor)) {
                valorRenderitzat = renderitzarValorTipusLlistaMultiple(valor, valorsPossibles);
            } else {
                valorRenderitzat = obtenirEtiquetaDeValorTipusLlista(valor, valorsPossibles);
            }

            break;

        case 8: { //Boolean
            valorRenderitzat = <Checkbox disabled checked={valor} />;

            if (!valorRenderitzat && valorRenderitzat !== 0) {
                valorRenderitzat = textQuanNoHiHaDada;
            }

            return <div className='camp salt-de-linia estacio-detall-variable-metadades-checkbox' key={id}>
                <span>{nom}:</span> {valorRenderitzat}
            </div>;

        }

        default:
            valorRenderitzat = tipusCampNoSuportat;
    }

    if (!valorRenderitzat && valorRenderitzat !== 0) {
        valorRenderitzat = textQuanNoHiHaDada;
    }

    return (
        <div className='camp salt-de-linia estacio-detall-variable-metadades' key={id}>
            <span>{nom}:</span> {valorRenderitzat}
        </div>
    );

};

const renderitzarGrups = grups => {

    let grupsRenderitzats = [];

    grups.forEach(grup => {

        if (grup.metadades.length <= 0) {
            return;
        }

        grupsRenderitzats.push(
            <Panel header={grup.nom} key={grup.id}>
                {renderitzarMetadades(grup.metadades)}
            </Panel>
        );
    });

    return grupsRenderitzats;
};

const renderitzarMetadades = metadades => {
    return metadades.map(metadada => {
        return (
            <Card key={metadada.id} title={metadada.nom} className='estacio-metadades-caixa-metadada'>
                {metadada.camps.map(camp => renderitzarCampSegonsTipus(camp))}
            </Card>
        );
    });
};

const EstacioDetallMetadades = (props) => {

    const { metadades } = props;

    const grupsRenderitzats = renderitzarGrups(metadades);

    if (grupsRenderitzats.length <= 0) {
        return <div className='estacio-metadades-sense-dades'>Sense dades</div>;
    }

    return (
        <Collapse bordered={false}>
            {grupsRenderitzats}
        </Collapse>
    );
};

EstacioDetallMetadades.propTypes = {
    metadades: PropTypes.array
};

export default EstacioDetallMetadades;



// WEBPACK FOOTER //
// ./src/components/estacio/estacioDetallMetadades.js